export default __webpack_public_path__ + "static/media/login-background.38dfcaa4.jpg";